'use client';
import { UploadCloud02 } from '@ethsign/icons';

import { Button } from '@ethsign/ui';

interface Props {
  title: string;
  subtitle: string;
  hideButton?: boolean;
  onUpload?: (file: any) => void;
}

export function TopArea(props: Props) {
  const { title, subtitle, hideButton, onUpload } = props;
  return (
    <div className="min-h-[91px] flex flex-row items-center justify-between px-5 border-b border-gray-200">
      <div className="flex flex-col justify-center h-full">
        <div className="text-[25px/34px] font-semibold font-semiBold text-gray-900 break-all">{title}</div>
        <div className="text-sm font-normal text-gray-500 mt-1">{subtitle}</div>
      </div>
      {!hideButton && (
        <Button size="lg" onClick={onUpload} className="border-none min-w-[226px] ml-5">
          <span className="mr-2">
            <UploadCloud02 size={20} color="#ffffff" />
          </span>
          Create New Contract
        </Button>
      )}
    </div>
  );
}
